import React, { FC, ReactElement, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { StyleSheetManager } from 'styled-components'
import MainComponent from 'components/MainComponent'
import DevTools from 'DevTools'
import tenants from 'Constants/tenants'

const App: FC<MicroFrontendProps> = (microFrontendProps): ReactElement => {
  const [ref, setRef] = useState<HTMLDivElement | null>()
  const styleRef = useRef<any>()
  const [cssIsInjected, setCssIsInjected] = useState(false)

  if (styleRef.current) {
    styleRef.current.onload = () => {
      setCssIsInjected(true)
    }
    styleRef.current.onerror = () => {
      // if we don't have any css file (if you use styled components)
      setCssIsInjected(true)
    }
  }

  return (
    <div id='root' ref={(newRef) => setRef(newRef)}>
      <link
        ref={styleRef}
        rel='stylesheet'
        href={
          process.env.REACT_APP_DEPLOY_PATH
            ? process.env.REACT_APP_DEPLOY_PATH + '/static/css/main.css'
            : 'static/css/main.css'
        }
      />
      {ref && cssIsInjected && (
        <div id='app'>
          <StyleSheetManager target={ref}>
            <MainComponent {...microFrontendProps} />
          </StyleSheetManager>
        </div>
      )}
    </div>
  )
}
export default App
if (window.document.title === 'TA-Interaktiv Microfrontend') {
  const DevToolAppWrapper: FC = (): ReactElement => {
    const [isDarkmode, setIsDarkmode] = useState(false)
    const [currentTenantKey, setCurrentTenantKey] =
      useState<TenantKey>('tagesanzeiger')
    return (
      <DevTools
        setTenant={setCurrentTenantKey}
        setIsDarkmode={setIsDarkmode}
        isDarkmode={isDarkmode}
        currentTenantKey={currentTenantKey}
      >
        <App
          tenant={
            tenants.find((tenant) => tenant.key === currentTenantKey) as Tenant
          }
          colorMode={isDarkmode ? 'dark' : 'light'}
          properties={{
            ausgabeGpt4:
              "In lindengr&uuml;nen Auen,<br>da weidet froh die Kuh,<br>derweil in weiter Ferne,<br>ein H&uuml;ndlein ruht im Nu.<br><br>Die sanften Glocken l&auml;uten,<br>so s&uuml;&szlig; ist ihr Gesang,<br>und in des Hundes Herzen,<br>entbrennt ein Sehnsuchtsdrang.<br><br>Tagt&auml;glich muss er schauen,<br>hin zu der bunten Kuh,<br>und fragt sich in Gedanken -<br>k&ouml;nnt' ich doch bei dir ruh'n?<br><br>Ein zaghaftes Erwachen,<br>des Hundes Liebe brennt,<br>er m&ouml;chte seine Tr&auml;ume,<br>putzmunter unverfremdt.<br><br>Er rennt zu ihr, die sch&ouml;ne,<br>wohl heimlich still in Ruh,<br>doch segnet er sein Gl&uuml;cke,<br>schon furchtbar ihm im Nu.<br><br>Die Kuh schaut stutzig, gr&uuml;&szlig;end,<br>so weich ihr Augenlicht,<br>und k&uuml;hn erwidert H&uuml;ndlein,<br>sein Herz, es bricht im Zwist.<br><br>Und so beginnt die Liebe,<br>der H&uuml;ndlein herzerweicht,<br>er tauscht sein Bein zum Lecken,<br>f&uuml;r sanftes Streicheln ein.<br><br>Der Duft von Heu und Honig,<br>bestimmt des Viehs Umfeld,<br>doch auch der Hundes Schwanzes,<br>wie flitternd' Licht er f&auml;llt.<br><br>Die Kuh, sie muht's im Stillen,<br>beginnt hierdurch das Schwanken,<br>zu lieben diesen Kauz so klein,<br>mit aller Seelenkraft?<br><br>Gemeinsam wandern sie nun,<br>durch Wiesen, Feld und Garten,<br>geviert die Schar von Pfoten,<br>die alle Lieben achten.<br><br>Ein Hund, der liebt die Kuh so,<br>dass niemand es versteh',<br>doch ihre Liebe von Herzen,<br>soll ewiglich bestehen.",
            eingabe:
              'Eine motivierende Lyrik zum Thema: Arbeit, Montag, Computer',
            ausgabe:
            "In lindengr&uuml;nen Auen,<br>da weidet froh die Kuh,<br>derweil in weiter Ferne,<br>ein H&uuml;ndlein ruht im Nu.<br><br>Die sanften Glocken l&auml;uten,<br>so s&uuml;&szlig; ist ihr Gesang,<br>und in des Hundes Herzen,<br>entbrennt ein Sehnsuchtsdrang.<br><br>Tagt&auml;glich muss er schauen,<br>hin zu der bunten Kuh,<br>und fragt sich in Gedanken -<br>k&ouml;nnt' ich doch bei dir ruh'n?<br><br>Ein zaghaftes Erwachen,<br>des Hundes Liebe brennt,<br>er m&ouml;chte seine Tr&auml;ume,<br>putzmunter unverfremdt.<br><br>Er rennt zu ihr, die sch&ouml;ne,<br>wohl heimlich still in Ruh,<br>doch segnet er sein Gl&uuml;cke,<br>schon furchtbar ihm im Nu.<br><br>Die Kuh schaut stutzig, gr&uuml;&szlig;end,<br>so weich ihr Augenlicht,<br>und k&uuml;hn erwidert H&uuml;ndlein,<br>sein Herz, es bricht im Zwist.<br><br>Und so beginnt die Liebe,<br>der H&uuml;ndlein herzerweicht,<br>er tauscht sein Bein zum Lecken,<br>f&uuml;r sanftes Streicheln ein.<br><br>Der Duft von Heu und Honig,<br>bestimmt des Viehs Umfeld,<br>doch auch der Hundes Schwanzes,<br>wie flitternd' Licht er f&auml;llt.<br><br>Die Kuh, sie muht's im Stillen,<br>beginnt hierdurch das Schwanken,<br>zu lieben diesen Kauz so klein,<br>mit aller Seelenkraft?<br><br>Gemeinsam wandern sie nun,<br>durch Wiesen, Feld und Garten,<br>geviert die Schar von Pfoten,<br>die alle Lieben achten.<br><br>Ein Hund, der liebt die Kuh so,<br>dass niemand es versteh',<br>doch ihre Liebe von Herzen,<br>soll ewiglich bestehen.",
          }}
        />
      </DevTools>
    )
  }
  const root = createRoot(document.getElementById('root')!)
  root.render(
    <React.StrictMode>
      <DevToolAppWrapper />
    </React.StrictMode>
  )
}
